type FunctionType = <T>(data: T[] | undefined | null) => boolean;

export const useShouldRenderArrayFC: FunctionType = data => {
    return (data?.length ?? 0) > 0;
};
